import { v4 } from "uuid";
import { FileManagerAPI } from "./api";
import { clipboardOperations } from "./constants";
import _ from "lodash";
import pako from "pako";
import convert from "convert-units";
export const INTERNAL_FOLDER_PATH = "designs/internal";
const emptyFileNode = {
  name: "",
  fullPath: "",
  location: "",
  filename: "",
  type: "file",
  variations: {},
  id: null,
  story: null,
};
const emptyFolderNode = {
  name: "",
  fullPath: "",
  location: "",
  level: 1,
  isExpanded: false,
  children: [],
  files: [],
  type: "folder",
};
const getFilenameFromPath = (path) => {
  const a = path.split("/").filter((item) => item && item !== "");
  return a[a.length - 1];
};
const getDesignStory = (fileNode, parentNode) => {
  const { Children } = parentNode;
  const { Name } = fileNode;
  const filtered = Children.filter((item) => item.Name[0] === ".");
  const varFolder = filtered.find((item) => item.Name.toLowerCase() === `.${Name.toLowerCase()}`);
  if (!varFolder) return null;

  const Info = uncompressJSON(varFolder.Info);
  const story = Info.story ? Info.story : Info;
  return story;
};
const findVariations = (fileNode, parentNode) => {
  const { Children } = parentNode;
  const { Name } = fileNode;
  const filtered = Children.filter((item) => item.Name[0] === ".");
  const varFolder = filtered.find((item) => item.Name.toLowerCase() === `.${Name.toLowerCase()}`);
  if (!varFolder) return {};
  const varFiles = varFolder.Children.filter((child) => child.Type === "file").map((item) => ({
    name: item.Name,
    type: item.Type,
    fullPath: item.FullPath,
    location: item.Location,
    filename: getFilenameFromPath(item.FullPath),
    id: v4(),
  }));
  if (varFiles.length) return { vars: varFiles };
  let colors = [];
  let shapes = [];
  const varColorsFolder = varFolder.Children.find(
    (child) => child.Type === "folder" && child.Name.toLowerCase() === "colors"
  );
  if (varColorsFolder) {
    colors = varColorsFolder.Children.filter((item) => item.Type === "file").map((item) => ({
      name: item.Name,
      type: item.Type,
      fullPath: item.FullPath,
      location: item.location,
      filename: getFilenameFromPath(item.FullPath),
    }));
  }
  const varShapesFolder = varFolder.Children.find(
    (child) => child.Type === "folder" && child.Name.toLowerCase() === "shapes"
  );
  if (varShapesFolder) {
    shapes = varShapesFolder.Children.filter((item) => item.Type === "file").map((item) => ({
      name: item.Name,
      type: item.Type,
      fullPath: item.FullPath,
      location: item.location,
      filename: getFilenameFromPath(item.FullPath),
    }));
  }
  return { colors, shapes };
};
export const arrangeDesignTree = ({ tree }) => {
  let designTree = {};
  let selectedFolder = {};
  let selectedDesign = {};
  traverse(tree[0], designTree);
  let hasInternal = false;
  function traverse(node, copyNode) {
    const { Children, Type, Name, FullPath, Location, Info } = node;
    const partitioned = _.partition(Children, (child) => child.Type === "file");
    const fileNodes = partitioned[0].map((fileNode) => ({
      type: fileNode.Type,
      name: fileNode.Name,
      fullPath: fileNode.FullPath,
      location: fileNode.Location,
      id: v4(),
      variations: findVariations(fileNode, node),
      filename: getFilenameFromPath(fileNode.FullPath),
      story: getDesignStory(fileNode, node),
    }));
    let folderNodes = partitioned[1].filter(
      (child) =>
        child.Type === "folder" && !fileNodes.find((item) => `.${item.name.toLowerCase()}` === child.Name.toLowerCase())
    );
    const level = FullPath.split("/").length - 1;
    const isInternal = FullPath.toLowerCase() === INTERNAL_FOLDER_PATH;
    if (isInternal) hasInternal = true;
    const isInternalChild = FullPath.toLowerCase().search(INTERNAL_FOLDER_PATH);
    copyNode["id"] = v4();
    copyNode["type"] = Type;
    copyNode["name"] = Name;
    copyNode["fullPath"] = FullPath;
    copyNode["location"] = Location;
    copyNode["level"] = level;
    copyNode["children"] = Array(folderNodes.length);
    copyNode["files"] = fileNodes;
    copyNode["isExpanded"] = level < 1 || isInternal;
    copyNode["isInternal"] = isInternalChild !== -1;

    const info = uncompressJSON(Info);
    copyNode["story"] = info.story ? info.story : info;
    if (fileNodes.length && !selectedFolder.id) {
      selectedFolder = copyNode;
      selectedDesign = fileNodes[0];
    }
    const internalFolderInd = folderNodes.findIndex(
      (folderNode) => folderNode.FullPath.toLowerCase() === INTERNAL_FOLDER_PATH
    );
    if (internalFolderInd !== -1) {
      folderNodes = reorder(folderNodes, internalFolderInd, folderNodes.length - 1);
    }
    folderNodes.forEach((folderNode, i) => {
      copyNode.children[i] = {};
      traverse(folderNode, copyNode.children[i]);
    });
  }
  console.log("arrangeDesignTree -> hasInternal", hasInternal);
  if (!hasInternal) {
    const internalFolderNode = {
      id: v4(),
      type: "folder",
      fullPath: "Designs/Internal",
      location: "Designs",
      level: 1,
      isExpanded: true,
      isInternal: true,
      story: null,
      children: [],
      files: [],
      name: "Internal",
    };

    designTree.children.push(internalFolderNode);
  }
  return { designTree, selectedFolder, selectedDesign };
};
export const updateFilesInNode = (tree, node, files) => {
  let arr = JSON.parse(JSON.stringify([tree]));
  arr.forEach(function iter(a) {
    if (a.id === node.id) {
      a.files = files;
      return;
    } else {
      Array.isArray(a.children) && a.children.forEach(iter);
    }
  });
  return arr[0];
};
export const updateNodeProps = (tree, node, key, value) => {
  let arr = JSON.parse(JSON.stringify([tree]));
  let updatedNode = node;
  arr.forEach(function iter(a) {
    if (a.id === node.id) {
      a[key] = value;
      updatedNode = { ...a };
      return;
    } else {
      Array.isArray(a.children) && a.children.forEach(iter);
    }
  });
  return { updatedTree: arr[0], updatedNode };
};
export const updateFileProps = (tree, fileNode, key, value) => {
  let arr = JSON.parse(JSON.stringify([tree]));
  let updatedNode = {};
  arr.forEach(function iter(a) {
    if (a.fullPath === fileNode.location) {
      a.files.forEach((file) => {
        if (file.id === fileNode.id) {
          if (key === "name") {
            file.fullPath = file.fullPath.replace(file.name, value);
            file.filename = file.filename.replace(file.name, value);
          }
          file[key] = value;
          console.log("AKSNd");
        }
      });
      updatedNode = { ...a };
      return;
    } else {
      Array.isArray(a.children) && a.children.forEach(iter);
    }
  });
  return { updatedTree: arr[0], updatedNode };
};
const remapFileNodes = (parentNode, fileNodes) => {
  return fileNodes.map((fileNode) => {
    //TODO: should update thumbUrl if exists?
    const id = v4();
    const location = parentNode.fullPath;
    const fullPath = fileNode.fullPath.replace(fileNode.location, parentNode.fullPath);
    return { ...fileNode, id, location, fullPath };
  });
};
export const pasteFilesFromClipboard = (tree, srcFiles, dstNode, operation) => {
  let arr = JSON.parse(JSON.stringify([tree]));
  let updatedNode = { ...dstNode };
  const srcIds = srcFiles.map((item) => item.id);
  arr.forEach(function iter(a) {
    if (operation === clipboardOperations.CUT) a.files = a.files.filter((item) => !srcIds.includes(item.id));
    if (a.id === dstNode.id) {
      const remappedFiles = remapFileNodes(dstNode, srcFiles);
      a.files = [...dstNode.files, ...remappedFiles];
      updatedNode = { ...a };
    } else {
    }
    Array.isArray(a.children) && a.children.forEach(iter);
  });
  return { updatedTree: arr[0], updatedNode };
};
export const pasteFoldersFromClipboard = (tree, srcNodes, dstNode, operation) => {
  let arr = JSON.parse(JSON.stringify(tree));
  let updatedNode = { ...dstNode };

  let mappedNodes = JSON.parse(JSON.stringify(srcNodes));
  let newLocation = dstNode.fullPath;
  let fileMap = [];
  let foldersPasted = [];
  const updateNode = (node) => {
    const fp = node.fullPath.replace(node.location, newLocation);
    newLocation = fp;
    const isInternal = fp.toLowerCase().search(INTERNAL_FOLDER_PATH) !== -1;
    foldersPasted.push(node);
    node["id"] = v4();
    node["location"] = newLocation;
    node["fullPath"] = fp;
    node["level"] = fp.split("/").length - 1;
    node["files"] = node.files.map((item) => {
      const newPath = item.fullPath.replace(item.location, fp);
      fileMap.push({ OldFile: item.fullPath, newFile: newPath });
      return {
        ...item,
        id: v4(),
        location: fp,
        fullPath: newPath,
      };
    });
    node["isInternal"] = isInternal;
    node.children.forEach((childNode) => updateNode(childNode));
  };
  mappedNodes.forEach((mappedNode) => updateNode(mappedNode));

  const traverseNode = (node) => {
    if (operation === clipboardOperations.CUT) {
      console.log(node.fullPath, srcNodes[0].location, node.id, dstNode.id);
      if (node.fullPath === srcNodes[0].location) console.log(node);
      node["children"] = node.children.filter((item) => !srcNodes.find((node) => node.id === item.id));
    }
    if (node.id === dstNode.id) {
      node["children"] = JSON.parse(JSON.stringify([...dstNode.children, ...mappedNodes]));
      updatedNode = { ...node };
    }
    node.children.forEach(traverseNode);
  };
  traverseNode(arr);
  return { updatedTree: arr, updatedNode, fileMap, foldersPasted };
};
export const renameFolder = (tree, node, value) => {
  let updatedNode = JSON.parse(JSON.stringify(node));
  let fullpath = updatedNode.location;
  updatedNode.name = value;

  remap(updatedNode);
  function remap(remapNode) {
    remapNode.location = fullpath;
    fullpath = `${fullpath}/${remapNode.name}`;
    remapNode.fullPath = fullpath;
    remapNode.files.forEach((file) => {
      file.fullPath = file.fullPath.replace(file.location, fullpath);
      file.location = fullpath;
    });
    remapNode.children.forEach(remap);
  }

  updatedNode.name = value;
  let arr = JSON.parse(JSON.stringify([tree]));
  arr.forEach(function iter(a) {
    const ind = a.children.findIndex((item) => item.id === updatedNode.id);
    if (ind !== -1) {
      a.children[ind] = updatedNode;
      return;
    }
    Array.isArray(a.children) && a.children.forEach(iter);
  });
  return { updatedTree: arr[0], updatedNode };
};
export const renameVariation = ({ designTree, design, name, varNode }) => {
  const { variations } = design;
  const newVars = variations.vars.map((item) => {
    if (item.id === varNode.id) {
      return {
        ...item,
        name,
        fullPath: item.fullPath.replace(item.name, name),
        filename: item.filename.replace(item.name, name),
      };
    }
    return item;
  });
  const newVariations = { ...variations, vars: newVars };
  const { updatedTree, updatedNode } = updateFileProps(designTree, design, "variations", newVariations);
  const updatedDesign = { ...design, variations: newVariations };
  return { updatedTree, updatedNode, updatedDesign };
};
function customizer(objValue, srcValue, key, object) {
  if (_.isArray(objValue)) {
    return objValue.concat(srcValue);
  }
}
export const addNewNode = (tree, node, merge) => {
  let arr = JSON.parse(JSON.stringify([tree]));
  arr.forEach(function iter(a) {
    if (a.fullPath === node.location) {
      a.isExpanded = true;
      if (!merge) {
        a.children = [...a.children, node];
        return;
      } else {
        const dupIndex = a.children.findIndex((item) => item.name.toLowerCase() === node.name.toLowerCase());
        a.children[dupIndex] = _.mergeWith(a.children[dupIndex], node, customizer);
        // a.children[dupIndex] = { ...a.children[dupIndex], files: a.children[dupIndex].files,  }
      }
      return;
    }
    Array.isArray(a.children) && a.children.forEach(iter);
  });
  return { updatedTree: arr[0] };
};
export const getFilesDeep = (parentNodes) => {
  let files = [];
  parentNodes.forEach(function iter(a) {
    files = [...files, ...a.files];
    Array.isArray(a.children) && a.children.forEach(iter);
  });
  return files;
};
export const addFilesinNode = ({ designTree, parentNode, files }) => {
  let arr = JSON.parse(JSON.stringify([designTree]));
  const mappedFiles = remapFileNodes(parentNode, files);
  let updatedNode = { ...parentNode };
  arr.forEach(function iter(a) {
    if (a.id === parentNode.id) {
      a.files = [...a.files, ...mappedFiles];
      a.files = Array.from(new Set(a.files.map((a) => a.name))).map((name) => {
        return a.files.find((a) => a.name === name);
      });
      a.isExpanded = true;
      updatedNode = { ...a };
      return;
    }
    Array.isArray(a.children) && a.children.forEach(iter);
  });
  return { updatedTree: arr[0], updatedNode };
};
export const removeFilesFromNode = ({ designTree, parentNode, files }) => {
  let arr = JSON.parse(JSON.stringify([designTree]));
  let updatedNode = { ...parentNode };
  arr.forEach(function iter(a) {
    if (a.id === parentNode.id) {
      a.files = a.files.filter((fileNode) => {
        return !files.find((item) => item.id === fileNode.id);
      });
      a.isExpanded = true;
      updatedNode = { ...a };
      return;
    }
    Array.isArray(a.children) && a.children.forEach(iter);
  });
  return { updatedTree: arr[0], updatedNode };
};
export const removeNodesFromTree = ({ designTree, nodes }) => {
  let arr = JSON.parse(JSON.stringify([designTree]));
  const parentLevel = nodes[0].level - 1;
  let updatedNode = { ...nodes[0] };
  arr.forEach(function iter(a) {
    if (a.level === parentLevel) updatedNode = { ...a };
    const filteredChildNodes = a.children.filter((childNode) => {
      return !nodes.find((item) => item.id === childNode.id);
    });
    a.children = filteredChildNodes;
    Array.isArray(a.children) && a.children.forEach(iter);
  });
  return { updatedTree: arr[0], updatedNode };
};
export const createTreeFromPaths = ({ parentNode, paths, rootName }) => {
  let result = [];
  paths.forEach((path) => {
    let currentLevel = result;
    let parts = path.split("/");
    if (rootName) {
      parts[0] = rootName;
    }
    let fp = "";
    parts.forEach((part, i) => {
      const name = getNameFromPath(part);
      const existingPath = findWhere(currentLevel, "name", name);

      const location = `${parentNode.fullPath}${fp}`;
      fp = `${fp}/${part}`;
      const fullPath = `${parentNode.fullPath}${fp}`;
      if (existingPath) currentLevel = existingPath.children;
      else {
        const isFile = i === parts.length - 1;
        const level = parentNode.level + i + 1;
        const type = isFile ? "file" : "folder";
        const newPart = {
          id: v4(),
          type,
          name,
          fullPath,
          location,
          level,
          isExpanded: true,
          children: [],
          files: [],
        };
        currentLevel.push(newPart);
        currentLevel = newPart.children;
      }
    });
  });
  return result[0];
};
export function findWhere(array, key, value) {
  let t = 0;
  while (t < array.length && array[t][key] !== value) {
    t++;
  }
  if (t < array.length) {
    return array[t];
  } else {
    return false;
  }
}
export const uploadFolder = async ({
  key,
  fileArray,
  operation,
  designTree,
  parentNode,
  onFileUpload,
  dims,
  forceUnit,
}) => {
  const uploadFileArray = fileArray.map((item, i) => {
    let relativePath = item.webkitRelativePath.split("/");
    if (operation === "rename") {
      relativePath[0] = `${relativePath[0]} 1`;
    }
    relativePath = relativePath.join("/");
    let dim;
    if (dims) dim = dims[i];
    return { fileObj: item, relativePath, dim };
  });
  const paths = uploadFileArray.map((item) => item.relativePath);
  let fileTree = createTreeFromPaths({ paths, parentNode });
  let newFileTree = JSON.parse(JSON.stringify(emptyFolderNode));

  const added = await FileManagerAPI.addFolder({ key, path: fileTree.fullPath });
  if (!added) return { updatedTree: designTree, updatedNode: parentNode };
  let fileNames = [];
  await traverse(fileTree, newFileTree);
  async function traverse(node, copyNode) {
    copyNode.name = node.name;
    copyNode.fullPath = node.fullPath;
    copyNode.location = node.location;
    copyNode.id = node.id;
    copyNode.type = node.type;
    copyNode.level = node.level;
    copyNode.isInternal = node.fullPath.toLowerCase().search(INTERNAL_FOLDER_PATH) !== -1;
    const fileNodes = node.children
      .filter((item) => item.type === "file")
      .map((item) => ({
        name: item.name,
        fullPath: item.fullPath,
        location: item.location,
        filename: getFilenameFromPath(item.fullPath),
        type: item.type,
        id: item.id,
        variations: {},
      }));
    const folderNodes = node.children.filter((item) => item.type === "folder");
    copyNode.files = [];
    for (let index = 0; index < fileNodes.length; index++) {
      const fileNode = fileNodes[index];
      const file = uploadFileArray.find((item) => `${parentNode.fullPath}/${item.relativePath}` === fileNode.fullPath);
      if (file) {
        const { dim, fileObj } = file;
        let width, length;
        if (dim) {
          const { physicalWidth, physicalHeight, unit } = dim;
          width = convert(physicalWidth)
            .from(unit)
            .to("cm");
          length = convert(physicalHeight)
            .from(unit)
            .to("cm");
        }
        const uploaded = await FileManagerAPI.uploadFile({
          key,
          file: fileObj,
          path: node.fullPath,
          width,
          length,
          forceUnit,
        });
        if (!uploaded) return;
        copyNode.files.push(fileNode);
        fileNames.push(fileNode.filename);
        onFileUpload(fileNames);
      }
    }
    let i = 0;
    copyNode.children = [];
    for (let index = 0; index < folderNodes.length; index++) {
      const childNode = folderNodes[index];
      const added = await FileManagerAPI.addFolder({ key, path: node.fullPath });
      if (!added) return;
      copyNode.children.push(childNode);
      traverse(childNode, copyNode.children[i]);
      i++;
    }
  }
  const { updatedTree } = addNewNode(designTree, newFileTree);
  return { designTree: updatedTree, selectedFolders: [newFileTree] };
};
export const fileArrayToFileNode = (fileArray) =>
  fileArray.map((item) => {
    const name = getNameFromPath(item.name);
    let fullPath = `/${item.name}`;
    if (item.webkitRelativePath && item.webkitRelativePath !== "") {
      fullPath = item.webkitRelativePath;
    }
    const location = "";
    const type = "file";
    const filename = item.name;
    const variations = {};
    return { name, fullPath, location, type, filename, variations };
  });

export const uploadFiles = async ({ designTree, parentNode, key, dims, forceUnit = "", fileArray, onFileUpload }) => {
  let filesUploaded = [];
  for (let index = 0; index < fileArray.length; index++) {
    const file = fileArray[index];
    let width, height;
    if (dims) {
      const dimens = dims[index];
      width = convert(dimens.physicalWidth)
        .from(dimens.unit)
        .to("cm");
      height = convert(dimens.physicalHeight)
        .from(dimens.unit)
        .to("cm");
    }
    const uploaded = await FileManagerAPI.uploadFile({
      key,
      file: file,
      path: parentNode.fullPath,
      width: width,
      length: height,
      forceUnit: forceUnit,
    });
    if (uploaded) {
      filesUploaded.push(file);
      onFileUpload(filesUploaded);
    }
  }
  const files = fileArrayToFileNode(filesUploaded);
  const { updatedTree, updatedNode } = addFilesinNode({ designTree, parentNode, files });
  return { designTree: updatedTree, selectedFolders: [updatedNode] };
};
const multisplice = function(array /*, ...args */) {
  var args = Array.apply(null, arguments).slice(1);
  let removedArr = [];
  args.sort(function(a, b) {
    return a - b;
  });
  for (var i = 0; i < args.length; i++) {
    var index = args[i] - i;
    const [removed] = array.splice(index, 1);
    removedArr.push(removed);
  }
  return removedArr;
};
export const reorder = (list, startIndex, endIndex, selectionIndices) => {
  const result = Array.from(list);
  if (selectionIndices && selectionIndices.length) {
    const removedArr = multisplice(result, ...selectionIndices);
    result.splice(endIndex, 0, ...removedArr);
  } else {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
  }
  return result;
};
export const selectStartToEnd = ({ list, startNode, endNode }) => {
  const startIndex = list.findIndex((item) => item.id === startNode.id);
  const endIndex = list.findIndex((item) => item.id === endNode.id);
  let start = startIndex;
  let end = endIndex + 1;

  if (startIndex > endIndex) {
    start = endIndex;
    end = startIndex + 1;
  } else if (startIndex === endIndex) {
    end = endIndex + 1;
  }
  if (start > list.length) start = list.length;
  if (end > list.length) end = list.length;
  return list.slice(start, end);
};
export const toggleExpandNodes = (designTree, isExpanded) => {
  let arr = JSON.parse(JSON.stringify([designTree]));
  arr.forEach(function iter(a) {
    const fp = a.fullPath.toLowerCase();
    if (fp === "designs" || fp === INTERNAL_FOLDER_PATH) a.isExpanded = true;
    else a.isExpanded = isExpanded;
    Array.isArray(a.children) && a.children.forEach(iter);
  });
  return arr[0];
};
export const toggleSortDesigns = ({ designTree, selectedFolder, ascending }) => {
  let arr = JSON.parse(JSON.stringify([designTree]));
  let updatedFolder = selectedFolder;
  const fact = ascending ? 1 : -1;
  arr.forEach(function iter(a) {
    if (a.fullPath === selectedFolder.fullPath) {
      a.files.sort((x, y) => {
        if (x.name < y.name) return -1 * fact;
        if (x.name > y.name) return 1 * fact;
        return 0;
      });
      updatedFolder = { ...a };
      return;
    }
    Array.isArray(a.children) && a.children.forEach(iter);
  });
  return { updatedTree: arr[0], updatedFolder };
};
export const findDuplicateFiles = ({ selectedFolder, fileArray }) => {
  const files = fileArrayToFileNode(fileArray);
  return selectedFolder.files.filter((selFoldItem) => files.find((item) => item.name === selFoldItem.name));
};
export function convertNumberToFeetInch(f, unit) {
  if (unit !== "ft") return f;
  var ft = Math.floor(f);
  var inch = Math.round(12 * (f - ft));
  if (inch === 12) {
    ft++;
    inch = 0;
  }
  return ft + "′" + (inch > 0 ? inch + "″" : "");
}
export function convertFeetInchToNumber(f, unit) {
  if (unit !== "ft") return f;
  var rex = /[-+]?[0-9]*\.?[0-9]+/g;
  var match = f.match(rex);
  var feet, inch;
  if (match) {
    feet = parseFloat(match[0]);
    inch = match.length > 1 ? parseFloat(match[1]) : 0;
    if (feet > 0 && inch >= 0 && inch < 12) {
      return feet + inch / 12;
    }
  }
  return null;
}
export const getFileExtFromName = (name) => {
  const a = name.split(".");
  if (!a.length) return null;
  return a[a.length - 1];
};

export const getNameFromPath = (part) => {
  const ind = part.lastIndexOf(".");
  if (ind === -1) return part;
  return part.substring(0, ind);
};
export const filterFileArrFromExt = (fileArr, extArr) =>
  fileArr.filter((item) => extArr.includes(getFileExtFromName(item.name)));

export const uncompressJSON = (str) => {
  if (!str || str === "") return "";
  return safelyParseJSON(pako.inflate(base64ToBytes(str), { to: "string" }));
};

export const comperessJSON = (colors) => bytesToBase64(pako.deflate(JSON.stringify(colors), { to: "string" }));

export const safelyParseJSON = (json) => {
  // This function cannot be optimised, it's best to
  // keep it small!
  let parsed;
  try {
    parsed = JSON.parse(json);
  } catch (e) {
    // Oh well, but whatever...
  }
  return parsed; // Could be undefined!
};
export const deleteFolders = async ({ folders, apiKey, designTree }) => {
  if (!folders.length) return;
  let filesToDelete = [];
  let foldersToDelete = [];
  folders.forEach(traverse);
  function traverse(node) {
    filesToDelete.push(...node.files);
    if (node.files.variations && node.files.variations.vars) {
      filesToDelete.push(...node.files.variations.vars);
    }
    foldersToDelete.push(node);
    node.children.forEach(traverse);
  }
  foldersToDelete.sort((a, b) => {
    if (a.level < b.level) return 1;
    if (a.level > b.level) return -1;
    return 0;
  });
  for (let file of filesToDelete) {
    if (file.variations && file.variations.vars) {
      for (let variation of file.variations.vars) {
        await FileManagerAPI.deleteFile({ key: apiKey, file: variation.fullPath });
      }
      await FileManagerAPI.deleteFolder({ key: apiKey, path: file.variations.vars[0].location });
    }
    await FileManagerAPI.deleteFile({ key: apiKey, file: file.fullPath });
  }
  for (let index = 0; index < foldersToDelete.length; index++) {
    const path = foldersToDelete[index].fullPath;
    await FileManagerAPI.deleteFolder({ key: apiKey, path });
  }
  return removeNodesFromTree({ designTree, nodes: folders });
  // setDesignList({
  //   ...designList,
  //   designTree: updatedTree,
  //   selectedFolders: [updatedNode],
  // });
};
function bytesToBase64(bytes) {
  var binary = "";
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

function base64ToBytes(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes;
}
export const downloadObjectAsJson = (exportObj, exportName) => {
  var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
  var downloadAnchorNode = document.createElement("a");
  downloadAnchorNode.setAttribute("href", dataStr);
  downloadAnchorNode.setAttribute("download", exportName + ".json");
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
};
